export default "__VITE_ASSET__a9d5ee62__"